export enum CourseEnrollmentStates {
  // Aprobado
  Approved = 'A',
  // Reprobado
  Reject = 'R',
  // Pendiente
  Pending = 'P',
  // Incrito
  Enrolled = 'E',
  // Convalidado
  Validated = 'V',
}

export enum CourseValidationType {
  Internal = 'internal',
  RAP = 'rap',
  External = 'external',
}

export enum CourseValidationSubType {
  Proficiency = 'proficiency',
  Validation = 'validation',
}
